import styles from "./CourseCard.module.css";
import type {Course} from "../../../types/course/Course.tsx";
import { Link } from 'react-router-dom';

function CourseCard({ course }: { course: Course }) {
    return (
        <Link
            to={`/courses/${course.id}/${course.last_chapter_id}/${course.last_lesson_id}`}
            className={styles.courseCardLink}
        >
        <div className={ styles.courseCard }>
            <div className={ styles.courseImage }>
                <img src={ course.cover_image }/>
            </div>
            <div className={ styles.courseBody }>
                <h3 className={ styles.courseTitle }>{ course.title }</h3>
                <p className={ styles.courseDescription }>{ course.description }</p>
                <div className={ styles.courseTags }>
                    <span className={`${styles.courseTag} ${styles.courseTagLevel}`}>
                        <i className="fas fa-signal"></i> { course.level }
                    </span>
                    <span className={`${styles.courseTag} ${styles.courseTagDuration}`}>
                        <i className="fas fa-clock"></i> { course.formatted_duration }
                    </span>
                    <span className={`${styles.courseTag} ${styles.courseTagCategory}`}>{ course.category }</span>
                </div>
            </div>
        </div>
        </Link>
    );
}

export default CourseCard;
